import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { PostJobPropsType } from "../interface/job_board";
import { ChangePasswordField } from "../interface/users";

export const apiUpdateProfile = async (fieldValues: PostJobPropsType) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/update-profile`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetUser = async () => {
  try {
    const uri = `/users/user`;
    const cfg = await getRequestConfiguration({});

    const result = await Axios.get(uri, cfg);
    return result;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetUserPreference = async () => {
  try {
    const uri = `/users/preference`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiVerifyUserPassword = async (fieldValues: PostJobPropsType) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/user/password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiChangePassword = async (fieldValues: ChangePasswordField) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/user/password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.patch(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiToogleEmailNotification = async (isActive: boolean) => {
  const data = new URLSearchParams();
  data.append("isActive", isActive ? "true" : "false");

  try {
    const uri = `/users/email/notification`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.patch(uri, data, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiTooglePushNotification = async (isActive: boolean) => {
  try {
    const data = new URLSearchParams();
    data.append("isActive", isActive ? "true" : "false");

    const uri = `/users/pn/notification`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.patch(uri, data, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiSendFeedback = async (values: {
  type: string;
  description: string;
}) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/feedback`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiSubmitIssue = async (values: {
  issue_type: string;
  description: string;
}) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/issue`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiAllSubscriptions = async () => {
  try {
    const uri = `/users/subscriptions`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetFacilityUser = async () => {
  try {
    const uri = `/users/facility/users`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiCreateFacilityUser = async (fieldValues: {
  password: string;
  email: string;
  department: string;
  first_name: string;
  last_name: string;
}) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/facility/user`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiDeleteFacilityUser = async (userId: string) => {
  try {
    const uri = `/users/user/${userId}/delete`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.delete(uri, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiEditFacilityInfo = async (values: {
  contact_job_title: string;
  contact_name: string;
  phone_number: string;
  address: string;
  city: string;
  state: string;
  facility_size: string;
  specialties: string;
}) => {
  try {
    const uri = `/users/update-facility-profile`;

    const cfg = await getRequestConfiguration({
      "Content-Type": "application/json",
    });

    return await Axios.put(uri, values, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
